import {
  buildWorkspaceQuery,
  workspaceRequest,
} from "./workspaceApiShared";
import { normalizeWorkspace } from "../utils/workspacePresentation";

function normalizeWorkspaceList(rows) {
  return Array.isArray(rows) ? rows.map(normalizeWorkspace) : [];
}

export async function searchPublicWorkspaces(params = {}) {
  const rows = await workspaceRequest(
    `/workspaces/search${buildWorkspaceQuery(params)}`,
    {
      fallback: "Unable to load workspaces.",
    }
  );
  return normalizeWorkspaceList(rows);
}

export async function getPublicWorkspace(identifier, token = null) {
  const rawIdentifier = String(identifier || "").trim();
  if (!rawIdentifier) {
    throw new Error("Workspace identifier is required.");
  }

  if (/^\d+$/.test(rawIdentifier)) {
    try {
      const row = await workspaceRequest(`/workspaces/${rawIdentifier}`, {
        token,
        fallback: "Unable to load workspace.",
      });
      return normalizeWorkspace(row);
    } catch {
      const rows = await searchPublicWorkspaces();
      const match = rows.find((item) => String(item.id) === rawIdentifier);
      if (match) return match;
      throw new Error("Unable to load workspace.");
    }
  }

  const row = await workspaceRequest(
    `/workspaces/slug/${encodeURIComponent(rawIdentifier)}`,
    {
      fallback: "Unable to load workspace.",
    }
  );
  return normalizeWorkspace(row);
}

export async function updateWorkspaceMarketplaceState(workspaceId, payload, token) {
  const row = await workspaceRequest(`/workspaces/${workspaceId}/marketplace`, {
    method: "PUT",
    token,
    body: payload,
    fallback: "Unable to update listing visibility.",
  });
  return normalizeWorkspace(row);
}

export async function listWorkspacePublicationState(token, salonId = null) {
  const rows = await workspaceRequest(
    `/workspaces/managed/publication${buildWorkspaceQuery({ salon_id: salonId })}`,
    {
      token,
      fallback: "Unable to load publication state.",
    }
  );
  return normalizeWorkspaceList(rows);
}
